export const EARLY_QUALITY_MIN_REMAINING_OPEN_ENDED = 5;
export const EARLY_QUALITY_MAX_INTERVIEW_DURATION_MS = 10 * 60_000;
export const EARLY_QUALITY_MEDIA_WAIT_MS = 60_000;
export const EARLY_QUALITY_DEADLINE_MS = 120_000;
export const EARLY_QUALITY_DEADLINE_EXPIRED_FAILURE_TYPE =
  "EarlyQualityCheckDeadlineExpired";
export const EARLY_QUALITY_SKIPPED_FAILURE_TYPE = "EarlyQualityCheckSkipped";
export const DEFAULT_EARLY_EVALUATION_GUIDANCE =
  "This is an early prefix of an unfinished interview. Do not penalize the respondent for questions not yet asked or for how few questions have been answered so far. Assign low or fraud only when the observed evidence strongly suggests the completed interview would meet that category. A pattern that is only starting does not.";
